import './slider.js';
import './priority-nav.js';
import './nav.js';
import './vendor/jquery.bxslider.min.js';


$( document ).ready(function() {

    //Product video popup
    $('.video-trigger').click(function() {
        $("body").addClass('video-active');
        $(".video-container").css('z-index', '5');
        $(".video-container").addClass("video-container--show");
    });

    var urlDump = $('#video').attr('src');
    var url = $('#video').attr('src');

      $('.video-trigger').click(function(){
    	  $('#video').attr('src', urlDump);
      });

      $('.video-close').click(function(){
    	  $('#video').attr('src', '');
      	  $("body").removeClass('video-active');
          $(".video-container").removeClass("video-container--show");
          setTimeout(function(){
              $(".video-container").css('z-index', '-2');
          },300)
      });

      //sShorten footer contact info on mob
      var headerLocation = $('.header__location');
      var headerEmail = $('.header__email-text');

      if ($(window).width() < 660){
          $('.contact_info--tel').text('Call Us');
          $('.contact_info--email').text('Email Us');
          headerLocation.text('Location');
      }

});



// WEBPACK FOOTER //
// ./main.js